import PageHeader from "components/PageHeader";

const birdSpecies = [
  {
    key: "eagles",
    bg: "bg-gradient-to-br from-[#8b4513] to-[#d2691e]",
    name: "Bald Eagles",
    description:
      "Majestic symbols of freedom with impressive 8-foot wingspans",
    habitat: "Habitat: Mountains & Lakes",
  },
  {
    key: "parrots",
    bg: "bg-gradient-to-br from-[#dc143c] to-[#ff6347]",
    name: "Tropical Parrots",
    description:
      "Colorful and intelligent birds known for their vocal abilities",
    habitat: "Habitat: Rainforest",
  },
  {
    key: "owls",
    bg: "bg-gradient-to-br from-[#2f4f4f] to-[#696969]",
    name: "Great Horned Owls",
    description: "Silent nighttime hunters with exceptional hearing",
    habitat: "Habitat: Forests",
  },
  {
    key: "penguins",
    bg: "bg-gradient-to-br from-[#2c3e50] to-[#34495e]",
    name: "African Penguins",
    description:
      "Playful aquatic birds with distinctive black and white markings",
    habitat: "Habitat: Coastal Waters",
  },
  {
    key: "flamingos",
    bg: "bg-gradient-to-br from-[#ff69b4] to-[#ffb6c1]",
    name: "Chilean Flamingos",
    description: "Elegant wading birds famous for their pink coloration",
    habitat: "Habitat: Wetlands",
  },
  {
    key: "hawks",
    bg: "bg-gradient-to-br from-[#8b4513] to-[#a0522d]",
    name: "Red-tailed Hawks",
    description: "Skilled hunters with exceptional eyesight and agility",
    habitat: "Habitat: Open Fields",
  },
];

const conservationFeatures = [
  {
    title: "Breeding Programs",
    description:
      "Supporting endangered species through carefully managed breeding initiatives.",
  },
  {
    title: "Rehabilitation",
    description:
      "Caring for injured birds and preparing them for release back into the wild.",
  },
  {
    title: "Education",
    description:
      "Teaching visitors about bird behavior, conservation, and environmental protection.",
  },
];

const Birds = () => {
  return (
    <div className="min-h-screen pt-0">
      <PageHeader
        title="Our Birds"
        subtitle="Meet the incredible bird species that call Mysher Aviary home"
      />

      <div className="bg-white py-20 max-[768px]:py-[60px]">
        <div className="container">
          <div className="grid grid-cols-2 items-start gap-16 max-[968px]:grid-cols-1 max-[968px]:gap-8">
            <div className="mb-12">
              <h2 className="mb-8 text-4xl font-bold text-primary-blue max-[768px]:text-3xl">
                Bird Species
              </h2>
              <div className="grid grid-cols-[repeat(auto-fit,minmax(280px,1fr))] gap-8">
                {birdSpecies.map((bird) => (
                  <div
                    key={bird.key}
                    className="overflow-hidden rounded-xl bg-white shadow-[0_4px_15px_rgba(0,0,0,0.1)] transition-transform duration-300 hover:-translate-y-1.5"
                  >
                    <div className={`h-[200px] ${bird.bg}`} />
                    <h3 className="px-6 pb-2 pt-6 font-semibold text-primary-blue">
                      {bird.name}
                    </h3>
                    <p className="mb-4 px-6 text-[0.95rem] text-text-light">
                      {bird.description}
                    </p>
                    <span className="block px-6 pb-6 text-sm font-semibold text-accent-green">
                      {bird.habitat}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            <div className="mb-12">
              <h2 className="mb-8 text-4xl font-bold text-primary-blue max-[768px]:text-3xl">
                Conservation Efforts
              </h2>
              <p className="mb-8 text-lg leading-[1.7] text-text-light">
                At Mysher Aviary, we're dedicated to the conservation and
                protection of bird species through education, research, and
                rehabilitation programs.
              </p>

              <div className="mt-8">
                {conservationFeatures.map((feature, index) => (
                  <div
                    key={feature.title}
                    className={`mb-8 border-b border-[#e9ecef] pb-8 ${
                      index === conservationFeatures.length - 1
                        ? "mb-0 border-b-0"
                        : ""
                    }`}
                  >
                    <h3 className="mb-2 font-semibold text-primary-blue">
                      {feature.title}
                    </h3>
                    <p className="mb-0 text-text-light">
                      {feature.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Birds;
